<template>
    <v-container>
        <v-card>
            <v-card-title>
                <span class="headline">{{ $t('listCustomerDisplaySettings')|capitalize }}</span>
            </v-card-title>
            <v-card-text>
                <v-layout align-center justify-center row>
                    <v-flex>
                        <v-layout column>
                            <v-flex class="mb-2">
                                <v-switch v-model="showLastAgentMessage" v-on:change="updateLastAgentMessageConfig" :false-value="'0'" :true-value="'1'">
                                    <template v-slot:label>
                                        <div>
                                            {{ $t('showLastAgentMessage')|capitalize }}: <strong
                                                :class="showLastAgentMessage==='1'?'success--text':'error--text'">{{$t(showLastAgentMessage==='1'?'on':'off')|capitalize}}</strong>
                                        </div>
                                    </template>
                                </v-switch>
                                <v-switch v-model="showLastBotMessage" v-on:change="updateLastBotMessageConfig" :false-value="'0'" :true-value="'1'">
                                    <template v-slot:label>
                                        <div>
                                            {{ $t('showLastBotMessage')|capitalize }}: <strong
                                            :class="showLastBotMessage==='1'?'success--text':'error--text'">{{$t(showLastBotMessage==='1'?'on':'off')|capitalize}}</strong>
                                        </div>
                                    </template>
                                </v-switch>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import BotService from "@/services/bot.service";

export default {
        name: "ShowLastAgentMessageConfig",
        props: {
            botCode: String,
        },
        data() {
            return {
                showLastAgentMessage: "1",
                showLastBotMessage: "1",
                loadingDialog: true
            }
        },
        mounted() {
            if (this.botCode) {
                this.fetchConfig();
            }
        },
        methods: {
            updateLastAgentMessageConfig() {
                BotService.setAgentConfig_ShowLastAgentMessage(this.botCode, this.showLastAgentMessage)
                    .then(()=> {
                        this.$AppService.toastSuccess("Update agent config success.");
                })
                    .catch(()=>{
                    this.$AppService.toastError("Update agent config failed");
                })
            },
            updateLastBotMessageConfig() {
                BotService.setAgentConfig_ShowLastBotMessage(this.botCode, this.showLastBotMessage)
                    .then(()=> {
                        this.$AppService.toastSuccess("Update agent config success.");
                    })
                    .catch(()=>{
                        this.$AppService.toastError("Update agent config failed");
                    })
            },
            fetchConfig() {
                BotService.getAgentConfigs(this.botCode).then(() => {
                    this.showLastAgentMessage = this.$store.state.agentConfig.show_last_agent_message === "1" ? "1" : "0";
                    this.showLastBotMessage = this.$store.state.agentConfig.show_last_bot_message === "1" ? "1" : "0";
                });
            }

        },
        watch: {
            botCode() {
                if (this.botCode) {
                    this.fetchConfig();
                }
            },
        }
    }
</script>

<style scoped>

</style>
